import { render, staticRenderFns } from "./RepairScreen2.vue?vue&type=template&id=4fc28f38"
import script from "./RepairScreen2.vue?vue&type=script&lang=js"
export * from "./RepairScreen2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports